import React, { useCallback } from 'react';
import styles from './styles.css.js';
import InternalBox from '../../../box/internal';
import InternalStatusIndicator from '../../../status-indicator/internal';
import InternalSpaceBetween from '../../../space-between/internal';
import InternalExpandableSection from '../../../expandable-section/internal';
function getStatusIndicatorType(taskIndex, currentTaskIndex) {
    if (taskIndex < currentTaskIndex) {
        return 'success';
    }
    if (taskIndex === currentTaskIndex) {
        return 'in-progress';
    }
    return 'pending';
}
export function Task(_a) {
    var task = _a.task, taskIndex = _a.taskIndex, currentTaskIndex = _a.currentTaskIndex, expanded = _a.expanded, onToggleExpand = _a.onToggleExpand, i18nStrings = _a.i18nStrings;
    var statusIndicatorType = getStatusIndicatorType(taskIndex, currentTaskIndex);
    var onExpandChange = useCallback(function () {
        onToggleExpand(taskIndex);
    }, [onToggleExpand, taskIndex]);
    return (React.createElement("li", { className: styles.task },
        React.createElement(InternalSpaceBetween, { size: "xxs" },
            React.createElement("div", { className: styles['task-title'] },
                React.createElement(InternalStatusIndicator, { type: statusIndicatorType, iconAriaLabel: i18nStrings.labelsTaskStatus[statusIndicatorType] }),
                React.createElement(InternalBox, { variant: "h3", padding: { left: 'xxxs', top: 'xxxs', bottom: 'n' }, fontSize: "heading-xs", fontWeight: "normal", color: taskIndex < currentTaskIndex ? 'text-status-success' : 'text-status-inactive', className: styles['task-title'] }, i18nStrings.taskTitle(taskIndex, task.title))),
            React.createElement("div", { className: styles['expandable-section-wrapper'] },
                React.createElement(InternalExpandableSection, { header: i18nStrings.labelTotalSteps(task.steps.length), expanded: expanded, onChange: onExpandChange },
                    React.createElement("ol", { className: styles['step-list'] }, task.steps.map(function (step, stepIndex) { return (React.createElement("li", { key: stepIndex, className: styles.step },
                        React.createElement(InternalBox, { color: "text-body-secondary", fontSize: "body-m", padding: { left: 'l' }, className: styles['step-title'] }, i18nStrings.stepTitle(stepIndex, step.title)))); })))))));
}
//# sourceMappingURL=task.js.map